var _rect, _path, _circle, _circle2, _circle3, _circle4, _rect2, _path2, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 69,
    viewBox: "0 0 172 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 57.8682,
    y: 2.43945,
    width: 68.3737,
    height: 54.9431,
    fill: "#567793"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.349 12.21H142.61C158.521 12.21 171.419 25.1083 171.419 41.0191V52.5016H132.349V12.21Z",
    fill: "#87D5CC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76.7951,
    cy: 56.7746,
    r: 10.3781,
    fill: "#FFECDA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 145.166,
    cy: 56.7746,
    r: 10.3781,
    fill: "#FFECDA"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.2395,
    cy: 57.9944,
    r: 9.41784,
    stroke: "black",
    strokeWidth: 1.92061
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 147.611,
    cy: 57.9944,
    r: 9.41784,
    stroke: "black",
    strokeWidth: 1.92061
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 62.4945,
    y: 0.960305,
    width: 66.4531,
    height: 53.0225,
    stroke: "black",
    strokeWidth: 1.92061
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M129.644 15.6107H138.945C154.326 15.6107 166.794 28.079 166.794 43.4595V53.9817H129.644V15.6107Z",
    stroke: "black",
    strokeWidth: 1.92061
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 17.5781,
    y1: 13.694,
    x2: 41.9973,
    y2: 13.694,
    stroke: "black",
    strokeWidth: 1.92061
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.485351,
    y1: 28.3444,
    x2: 41.9979,
    y2: 28.3444,
    stroke: "black",
    strokeWidth: 1.92061
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 17.5781,
    y1: 42.9957,
    x2: 41.9973,
    y2: 42.9958,
    stroke: "black",
    strokeWidth: 1.92061
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.abaae325d08592020509d9b3c15edb51.svg";
export { ForwardRef as ReactComponent };